import { Paper, Typography } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';

import { useAuth } from '../../contexts/auth';
import ColorModeIconDropdown from '../../themes/MuiTheme/ColorModeIconDropdown';
import Subscriptions from '../subscriptions/activeSubscriptions';

export default function SubscribeForm() {
  const { user } = useAuth();
  return (
    <Paper
      elevation={3}
      variant='main'
      sx={{
        display: 'flex', // Flexbox engedélyezése
        flexDirection: 'column', // Oszlopirányba rendezi az elemeket
        alignItems: 'center',
        padding: 3,
        maxWidth: 1400,
        margin: '2% auto',
      }}
    >
      <div style={{ position: 'fixed', top: 30, right: 30 }}>
        <ColorModeIconDropdown size='medium' />
      </div>
      <Typography variant='subtitle1' textAlign='center' sx={{ mb: 2 }}>
        Válaszd ki a számodra megfelelő előfizetést a folytatáshoz.
      </Typography>
      {user ? (
        <Subscriptions redirectToOrder />
      ) : (
        <Subscriptions subscribeAndOrder />
      )}
      <Typography textAlign='center' sx={{ mt: 2 }}>
        <Link to='/'>Visszalépés</Link>
      </Typography>
    </Paper>
  );
}
